import React from 'react';
import cx from 'classnames';
import Checkbox from "@scentregroup/ui/components/form/checkbox";
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const TermsAndConditionsAndPrivacyStatementLabel = _ref => {
  let {
    termsAndConditionUrl,
    privacyPolicyUrl
  } = _ref;
  return /*#__PURE__*/_jsxs("span", {
    "data-id": "terms-and-conditions_terms-and-conditions_TermsAndConditionsAndPrivacyStatementLabel_span",
    children: [/*#__PURE__*/_jsxs("p", {
      "data-id": "terms-and-conditions_terms-and-conditions_TermsAndConditionsAndPrivacyStatementLabel_span_p",
      children: ["I have read and accepted the", ' ', /*#__PURE__*/_jsx("a", {
        className: style.link,
        href: termsAndConditionUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        "data-id": "terms-and-conditions_terms-and-conditions_TermsAndConditionsAndPrivacyStatementLabel_p_a",
        children: "Terms and Conditions"
      }), ' ', "and", ' ', /*#__PURE__*/_jsx("a", {
        className: style.link,
        href: privacyPolicyUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        "data-id": "terms-and-conditions_terms-and-conditions_TermsAndConditionsAndPrivacyStatementLabel_p_a_3",
        children: "Privacy Policy"
      }), "."]
    }), /*#__PURE__*/_jsx("p", {
      "data-id": "terms-and-conditions_terms-and-conditions_TermsAndConditionsAndPrivacyStatementLabel_span_p",
      children: "We protect all Personal Information in accordance with applicable Australian and New Zealand privacy laws."
    })]
  });
};

const TERMS_AND_CONDITIONS_ID = 'termsAndConditions';

const TermsAndConditionsAndPrivacyStatement = _ref2 => {
  let {
    disabled,
    value,
    errorMessage,
    onChange,
    termsAndConditionUrl,
    privacyPolicyUrl
  } = _ref2;

  const onCheckboxChange = () => {
    onChange(!value);
  };

  return /*#__PURE__*/_jsx(Checkbox, {
    size: "SMALL",
    disabled: disabled,
    id: TERMS_AND_CONDITIONS_ID,
    checked: value,
    errorMessage: errorMessage,
    label: TermsAndConditionsAndPrivacyStatementLabel({
      termsAndConditionUrl,
      privacyPolicyUrl
    }),
    classNames: {
      label: cx(style.checkboxLabel, {
        [style.error]: errorMessage
      })
    },
    onChange: onCheckboxChange,
    "data-id": "terms-and-conditions_terms-and-conditions_TermsAndConditionsAndPrivacyStatementLabel_Checkbox"
  });
};

export default TermsAndConditionsAndPrivacyStatement;